<template>
  <div class="flex w-full justify-center safe-area-inset-padding-top">
    <div class="container m-5 relative">
      <div class="flex justify-between">
        <div
          class="bigger-clickable-area cursor-pointer z-50"
          @click="router.push('/logout')"
        >
          <klereo-icon name="arrow-left" />
        </div>

        <div
          class="bigger-clickable-area cursor-pointer z-50"
          @click="poolsListRef.refresh()"
        >
          <klereo-icon name="refresh" />
        </div>
      </div>

      <div class="flex flex-col absolute top-0 bottom-0 left-0 right-0">
        <div class="flex justify-center mb-5">
          <img src="@/assets/images/logo.svg" :alt="variant.appName" />
        </div>
        <p class="text-white text-center font-medium mb-5">
          {{ $t("PleasePickPool") }}
        </p>

        <div class="flex-shrink flex-grow overflow-hidden">
          <pools-list ref="poolsListRef" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import PoolsList from "@/features/pools/PoolsList.vue";
import KlereoIcon from "@/shared/components/KlereoIcon.vue";
import { useRouter } from "vue-router";
import { ref } from "vue";
import { variant } from "@/core/variant.ts";

const router = useRouter();
const poolsListRef = ref();
</script>
